import { lighten } from '@mui/material/styles';

// Mirrors material-react-table's own baseBackgroundColor so the pinned first
// column matches the cells beside it. MRT lightens background.default on dark
// rather than using background.paper.
const stickyColumnBackground = theme =>
  theme.palette.mode === 'dark'
    ? lighten(theme.palette.background.default, 0.05)
    : theme.palette.background.default;

function convertSchemaToColumns(
  schema,
  formatMessage,
  accessorFunctions,
  accessorFunctionsAdditional = {},
  stickyColumn = false,
) {
  return schema.map((schemaItem, index) => ({
    ...(stickyColumn &&
      index === 0 && {
        muiTableHeadCellProps: {
          sx: theme => ({
            position: 'sticky',
            left: 0,
            zIndex: 2,
            backgroundColor: stickyColumnBackground(theme),
          }),
        },
        muiTableBodyCellProps: {
          sx: theme => ({
            position: 'sticky',
            left: 0,
            zIndex: 1,
            backgroundColor: stickyColumnBackground(theme),
          }),
        },
      }),
    accessorKey: schemaItem.accessorKey,
    header: schemaItem.header
      ? formatMessage({
          id: schemaItem.header.localeId,
          defaultMessage: schemaItem.header.defaultMessage,
        })
      : null,
    // number which converts to width in pixels
    ...(schemaItem?.size !== undefined && {
      size: schemaItem.size,
    }),
    ...(schemaItem?.enableColumnActions !== undefined && {
      enableColumnActions: schemaItem.enableColumnActions,
    }),
    ...(schemaItem?.enableHiding !== undefined && {
      enableHiding: schemaItem.enableHiding,
    }),
    ...(schemaItem?.enableSorting !== undefined && {
      enableSorting: schemaItem.enableSorting,
    }),
    ...(schemaItem?.accessorFn && {
      Cell: props => {
        const {
          row: { original },
        } = props;
        if (typeof accessorFunctions[schemaItem.accessorFn] === 'function') {
          return accessorFunctions[schemaItem.accessorFn](
            original,
            props,
            accessorFunctionsAdditional,
          );
        }
        throw new Error(
          `Function ${schemaItem.accessorFn} does not exist column definition`,
        );
      },
    }),
  }));
}

export default convertSchemaToColumns;
